/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid400,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid401,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionDashboardClassroomdisciplineid.ts";

function getGetApiV1ExamCorrectionDashboardClassroomdisciplineidUrl(
  classroomDisciplineId: GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams["classroomDisciplineId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/correction-dashboard/${classroomDisciplineId}` as const,
  };
  return res;
}

/**
 * @description Retorna os detalhes do painel de correções para uma disciplina específica da sala de aula. **(Requer Authorization para autenticação)**
 * @summary Detalhe do painel de correção (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-dashboard/:classroomDisciplineId}
 */
export async function getApiV1ExamCorrectionDashboardClassroomdisciplineid(
  classroomDisciplineId: GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams["classroomDisciplineId"],
  params?: GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid400
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid401
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamCorrectionDashboardClassroomdisciplineidUrl(
      classroomDisciplineId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
